/*
  NO FUGAZI — search across the whole site.

  Shopify's own search only reads a page's BODY field. On this site every word of
  the garment and guide pages lives in theme sections instead, so the native
  index is effectively empty: measured, "print on demand", "loopback", "rib
  depth" and "acid wash" each returned the same 13 pages, which is Shopify
  matching nothing and listing everything. Only page TITLES were searchable,
  which is why "hoodie" worked and "french terry" returned nothing.

  So this searches a prebuilt index of the rendered pages (assets/nf-search-index.json,
  regenerate with scripts/build-index). Products keep coming from Shopify's
  predictive search, which works properly because products do have real fields;
  this adds the pages, guides and articles underneath.

  Deliberate choices:
    - The index is fetched on first interaction, never on page load. It is 110KB
      and most visitors never open search; making everyone pay for it would be a
      poor trade.
    - Results are appended as a SIBLING of the theme's results container, not
      inside it. The theme replaces that container's innerHTML on every
      keystroke, so anything injected into it is wiped on the next fetch.
    - Matching requires ALL query tokens to be present. Any-token matching turned
      "custom hoodie" into a list of every page mentioning "custom", which is all
      of them.
*/
(function () {
  'use strict';

  var INDEX_URL = window.NF_SEARCH_INDEX_URL;
  var WA = 'https://wa.me/447537134878?text=';
  var MAX = 6;

  var index = null, loading = null;

  function load() {
    if (index) return Promise.resolve(index);
    if (loading) return loading;
    loading = fetch(INDEX_URL)
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (j) { index = j; return j; })
      .catch(function () { return null; });
    return loading;
  }

  function tokenise(s) {
    return (s.toLowerCase().match(/[a-z][a-z0-9'-]{1,}/g) || [])
      .map(function (w) { return w.replace(/'s$/, ''); })
      .filter(function (w) { return w.length >= 2; });
  }

  function search(q) {
    if (!index) return [];
    var terms = tokenise(q);
    if (!terms.length) return [];

    var scores = Object.create(null), hits = Object.create(null);

    terms.forEach(function (t) {
      // exact token, else treat a short query as a prefix so results appear
      // while the person is still typing
      var postings = index.i[t];
      if (!postings) {
        var pref = [];
        for (var w in index.i) {
          if (w.lastIndexOf(t, 0) === 0) { pref = pref.concat(index.i[w]); if (pref.length > 400) break; }
        }
        postings = pref.length ? pref : null;
      }
      if (!postings) return;
      var seenThisTerm = Object.create(null);
      for (var i = 0; i < postings.length; i += 2) {
        var id = postings[i], freq = postings[i + 1];
        scores[id] = (scores[id] || 0) + freq;
        if (!seenThisTerm[id]) { hits[id] = (hits[id] || 0) + 1; seenThisTerm[id] = 1; }
      }
    });

    var out = [];
    for (var id in scores) {
      if (hits[id] < terms.length) continue;      // every term must appear
      var p = index.p[id];
      if (!p) continue;
      var s = scores[id];
      if (p.t && p.t.toLowerCase().indexOf(q.toLowerCase()) !== -1) s += 40;
      if (p.k === 'page') s += 6;                 // the manufacturing pages are the answer more often than a blog post
      out.push({ p: p, s: s });
    }
    out.sort(function (a, b) { return b.s - a.s; });
    return out.slice(0, MAX).map(function (x) { return x.p; });
  }

  var LABEL = { page: 'Page', product: 'Guide', article: 'Article', collection: 'Collection' };

  /*
    Shopify's predictive search only knows about the 7 products, so a query like
    "french terry" leaves "No products were found matching your selection."
    sitting directly above a list of pages that plainly were found. Hide that
    line when this index has answers, and put it back when it does not — a
    search that genuinely finds nothing still has to say so.
  */
  function syncEmptyState(host, hasResults) {
    var box = host.parentNode && host.parentNode.querySelector('[data-results-search]');
    if (!box) return;

    // Toggle a CLASS, never innerHTML. The theme refetches on every keystroke
    // and rewrites this container's innerHTML, so anything written into it is
    // overwritten a moment later — the first attempt cleared the message and
    // the theme's own response promptly put it back. A class on the element
    // itself survives, because innerHTML replacement does not touch the node.
    var hasProducts = !!box.querySelector('.t4s-product, [class*="widget_if_pr"], a[href*="/products/"]');
    box.classList.toggle('nf-hide-empty', !!hasResults && !hasProducts);

    // and re-apply after the theme's own response lands
    if (!box.__nfObs) {
      box.__nfObs = new MutationObserver(function () {
        if (box.__nfBusy) return;
        box.__nfBusy = true;
        setTimeout(function () {
          box.__nfBusy = false;
          var stillHas = !!box.querySelector('.t4s-product, [class*="widget_if_pr"], a[href*="/products/"]');
          var mine = host.querySelectorAll('.nf-sr__it').length > 0;
          box.classList.toggle('nf-hide-empty', mine && !stillHas);
        }, 0);
      });
      box.__nfObs.observe(box, { childList: true, subtree: true, characterData: true });
    }
  }

  function render(host, results, q) {
    if (!results.length) { host.innerHTML = ''; syncEmptyState(host, false); return; }
    syncEmptyState(host, true);
    var h = '<div class="nf-sr__head">Pages &amp; guides</div><ul class="nf-sr__list">';
    results.forEach(function (p) {
      h += '<li class="nf-sr__it"><a href="' + p.u + '">' +
           '<span class="nf-sr__k">' + (LABEL[p.k] || 'Page') + '</span>' +
           '<span class="nf-sr__t">' + esc(p.t) + '</span>' +
           (p.d ? '<span class="nf-sr__d">' + esc(p.d) + '</span>' : '') +
           '</a></li>';
    });
    h += '</ul>';
    host.innerHTML = h;
  }

  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"]/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c];
    });
  }

  function hostFor(input) {
    var scroll = input.closest('.t4s-drawer, .t4s-mini-search, form');
    var drawer = input.closest('.t4s-drawer__content') ||
                 (input.closest('.t4s-drawer') || document).querySelector('.t4s-drawer__content');
    var anchor = (drawer || document).querySelector('[data-results-search]');
    if (!anchor || !anchor.parentNode) return null;
    var host = anchor.parentNode.querySelector('.nf-sr');
    if (!host) {
      host = document.createElement('div');
      host.className = 'nf-sr';
      anchor.parentNode.insertBefore(host, anchor.nextSibling);
    }
    return host;
  }

  function wire(input) {
    if (input.__nfWired) return;
    input.__nfWired = true;

    var t = null;
    var run = function () {
      var q = input.value.trim();
      var host = hostFor(input);
      if (!host) return;
      if (q.length < 2) { host.innerHTML = ''; return; }
      load().then(function () {
        if (input.value.trim() !== q) return;      // a later keystroke already won
        render(host, search(q), q);
      });
    };

    input.addEventListener('input', function () { clearTimeout(t); t = setTimeout(run, 140); });
    input.addEventListener('focus', load, { once: true });
  }

  function scan() {
    document.querySelectorAll('[data-input-search]').forEach(wire);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', scan);
  else scan();

  // the drawers are injected late by the theme, so keep watching for new inputs
  new MutationObserver(function () { scan(); })
    .observe(document.documentElement, { childList: true, subtree: true });
})();
